import { clientWithoutErrorHandling } from '../http';
import DDLogs from '../DDLogs';
import anonymousSession from '../anonymousSession';

export default {
  async getTreatment(flagName) {
    try {
      DDLogs.log(`Getting feature flag treatment - ${flagName}`);
      const response = await clientWithoutErrorHandling.get(`/api/feature-flag/${flagName}`, {});
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        DDLogs.error(`Failed to get feature flag treatment - got 403 forbidden - ${flagName}`, { error });
      } else {
        DDLogs.error('Failed to get feature flag treatment', { error });
      }
      return 'off';
    }
  },
  async getAnonymousTreatment(flagName) {
    try {
      const anonymousId = anonymousSession.getId();
      const response = await clientWithoutErrorHandling.get(`/api/no-auth/anonymous-feature-flag/${flagName}/${anonymousId}`, {});
      return response.data;
    } catch (error) {
      DDLogs.error('Failed to get anonymous feature flag treatment', { error });
      return 'control';
    }
  },
};
